import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Route, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { User } from '@shared/models/user';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { CommonService } from './common.service';
import { MaintenanceService } from './maintenance.service';
import { UserService } from './user.service';

@Injectable({
    providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanActivateChild {

    constructor(
        private commonService: CommonService,
        private maintenanceService: MaintenanceService,
        private userService: UserService,
        private router: Router
    ) { }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.checkUser(route, state);
    }

    canActivateChild(
        childRoute: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
        return this.checkUser(childRoute, state);
    }

    private checkUser(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> {
        return this.userService.getLoggedUser().pipe(map((loggedUser: User) => {
            if (this.maintenanceService.isMaintenance) {
                return this.router.parseUrl('/maintenance');
            }

            if (loggedUser.authenticated && loggedUser.role) {
                let allowed = false;

                if (route.data.roles.includes(loggedUser.role)) {
                    if (route.data.agentSource == undefined) {
                        allowed = true;
                    }

                    if (!allowed && route.data.agentSource.includes(loggedUser.agentSource)) {
                        allowed = true;
                    }
                }

                if (allowed) {
                    this.setActiveMenuItem(route);
                    return true;
                }

                return this.router.parseUrl('');
            }

            document.location.href = this.commonService.loginUrl;
            return false;

        }, this));
    }

    private setActiveMenuItem(route: ActivatedRouteSnapshot) {
        let currentPath: string;

        if (route.routeConfig.data !== undefined && route.routeConfig.data.active !== undefined) {
            currentPath = route.routeConfig.path;

            if (route.routeConfig.data.activatePath !== undefined) {
                currentPath = route.routeConfig.data.activatePath;
            }

            this.router.config.filter((routerRoute: Route) => {
                routerRoute.data.active = false;
                if (routerRoute.path == currentPath) {
                    routerRoute.data.active = true;
                }
            });

        }
    }

}
